<template>
	<div class="menu_box border_bottom_dashed" style="border-top: none;border-bottom: none;">
		<div class="flex borderBottomDashed paddingAll20">
			<div class="title_shaixuan flex_jc_center">工队类型</div>
			<div class="classified_content" :style="{height:show?'auto':'46px'}" ref="height">
        <div class="unfold flex_ai_center" :class="show?'unfold-red':''" @click="show=!show" v-if="height">
          <span v-show="show">收起<i class="el-icon-arrow-up"></i></span>
          <span v-show="!show">展开<i class="el-icon-arrow-down"></i></span>
        </div>
				<span v-for="(item, index) in teamType" :key="'team'+index" :class="{ pitch_on: teamIndex==index }"
              @click="send(item, index)">
					{{ item.name }}
				</span>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "teamType",
		data() {
			return {
				teamType: [
          { name: "全部", no: "" },
          { name: "施工队", no: 0 },
          { name: "班组工队", no: 1}
        ],
				teamIndex: '',
        show:true,
        height:false,
			}
		},
		watch: {},
		created() {
		},
		methods: {
			/** @name 搜索单项 */
			send(obj, key) {
        this.teamIndex = key;
        if(key==0){
          this.$parent.$refs.screen.teamType=[]
          return
        }
        obj.key = key;
				//替换搜索项
				let type = this.$parent.$refs.screen.teamType.length;
				if (type) {
					this.$parent.$refs.screen.teamType.splice(0, 1, obj)
					return
				}
				//添加搜索项
				this.$parent.$refs.screen.teamType.push(obj)
			},
			/** @name 清队单项 */
			close(item) {
				this.teamIndex = ''
			},
			/** @name 清空所有 */
			closeall() {
				this.teamIndex = ''
			}
		},
	}
</script>

<style scoped>

</style>
